import script from "./MintCollateral.vue?vue&type=script&setup=true&lang=js"
export * from "./MintCollateral.vue?vue&type=script&setup=true&lang=js"

import "./MintCollateral.vue?vue&type=style&index=0&id=1cae266c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1cae266c"]])

export default __exports__